<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <h4 class="card-title">Recurring Payments</h4>
              <p class="card-category">Regular donations made to your causes</p>
            </template>
            <div>
              <el-input placeholder="Filter by ..." v-model="filter.text" class="input-with-select">
                <el-select v-model="filter.by" slot="prepend" placeholder="Select">
                  <el-option label="Cause" value="cause"></el-option>
                  <el-option label="Donor" value="donor"></el-option>
                  <el-option label="Date" value="date"></el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <el-table
              class="itf-table payments"
              :cell-class-name="cellClass"
              :data="filteredData"
              style="width: 100%"
              :stripe="true"
              empty-text="No Data"
            >
              <el-table-column prop="amount" label="Amount" width="80">
                <template slot-scope="scope">
                  <router-link :to="'/me/finance/recurring/' + scope.row.id">{{scope.row.amount}}</router-link>
                </template>
              </el-table-column>
              <el-table-column prop="currency" label="" width="50" class="currency">
              </el-table-column>
              <el-table-column prop="status" label="" width="100">
                <template slot-scope="scope">
                  <span :class="statusClass(scope.row.status)">{{ scope.row.status | status }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="causeName" label="Cause" width="280">
              </el-table-column>
              <el-table-column prop="email" label="Donor" width="280">
              </el-table-column>
              <el-table-column prop="dtc" label="Date" width="180">
              </el-table-column>
            </el-table>
            <!-- <button class="btn btn-primary">some button</button> -->
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, reactive, ref, onMounted } from '@vue/composition-api'
import graphql from '@/api/graphql'
import gql from 'graphql-tag'
import router from '@/routes/router'
import BaseRadio from '@/components/Forms/BaseRadio.vue'
import RecurringStatus from '@/pages/Finance/RecurringStatus.js'

export default {
  components: {
    BaseRadio
  },
  setup(props, context) {
    const root = context.root
    const store = root.$store
    const tableData = ref([])
    let profile = store.state.users.profile

    onMounted(() => {
      let graphQuery = gql`{
        recurringList {
          id,
          amount,
          currency,
          status,
          causeName,
          email,
          dtc
        }
      }`
      graphql.query(graphQuery)
        .then(json => {
          tableData.value = json.data.recurringList
        })
        .catch(gqlResponse => {
          graphql.handleError(gqlResponse, 'Error getting recurring payment list:', store.dispatch)
        })
    })

    // Text Filter
    const filter = reactive({
      by: 'donor',
      text: ''
    })
    const filteredData = computed(() => {
      return tableData.value.filter(item => {
        let filterText = filter.text.toLowerCase()
        if (filterText == '') {
          return true
        }
        if (filter.by == 'donor') {
          return item.email.toLowerCase().includes(filterText)
        }
        else if (filter.by == 'cause') {
          return item.causeName.toLowerCase().includes(filterText)
        }
        else if (filter.by == 'date') {
          return item.dtc.includes(filterText)
        }
        return true
      })
    })
    const hasFilteredData = computed(() => {
      var result = filteredData.value.length > 0
      // console.log('hasFilteredData', filteredData.value, result)
      return result
    })
    function cellClass(v) {
      if (v.columnIndex == 0) {
        return 'amount'
      }
      else if (v.columnIndex == 1) {
        return 'currency'
      }
      else if (v.columnIndex == 2) {
        return 'status'
      }
      return null
    }

    // setup return
    return {
      cellClass,
      filter,
      filteredData,
      hasFilteredData,
      'statusClass': RecurringStatus.statusClass,
    }
  },
  filters: {
    status: function (value) {
      const map = {
        active: 'active',
        fail: 'failed',
        more: 'incomplete',
        pending: 'incomplete',
        cancel: 'cancelled'
      }
      if (value in map) {
        return map[value]
      }
      return value
    }
  }

}
</script>
<style lang="scss">
  .el-select .el-input {
    width: 110px;
  }
</style>